<template>
  <nav>
    <v-toolbar>
      <v-toolbar-title class="text-uppercase">
        <router-link to="/" class="toolbar-title">
          <span class="font-weight-light">Schedule</span>
          <span>Manager</span>
        </router-link>
      </v-toolbar-title>

      <v-spacer/>

      <!-- I don't like this since it calls the getNextEvent() method multiple times, and that method isn't really lightweight. -->
      <div v-if="isLoggedIn">
        <v-btn flat color="success" v-if="getNextEvent !== null && getNextEvent.assignments === null">
          <span>Add Crew Assignment</span>
          <v-icon right>add</v-icon>
        </v-btn>
        <v-btn flat color="warning" v-else-if="getNextEvent !== null">
          <span>Edit Crew Assignment</span>
          <v-icon right>edit</v-icon>
        </v-btn>

        <v-btn flat color="error" @click="logout">
          <span>Sign Out</span>
          <v-icon right>exit_to_app</v-icon>
        </v-btn>
      </div>

      <div v-else>
        <v-btn flat color="success" route to="login">
          <span>Login</span>
          <v-icon right>person</v-icon>
        </v-btn>
      </div>
    </v-toolbar>

    <v-snackbar v-model="showLogoutSnackbar" :top=true>
      Successfully Logged Out
      <v-btn color="pink" flat @click="showLogoutSnackbar = false">Close</v-btn>
    </v-snackbar>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      showLogoutSnackbar: false
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    getNextEvent() {
      const events = this.$store.state.events.sort((a, b) => b.date.toDate() - a.date.toDate());

      for (const event of events) {
        if (event.date.toDate() > Date.now()) {
          return event;
        }
      }

      return null;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('userSignOut').then(() => {
        this.showLogoutSnackbar = true;
      });
    }
  }
};
</script>

<style>
  .toolbar-title {
    color: white;
    text-decoration: none;
  }
</style>
